import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    contestId: Number,
    boardId: Number,
  };

  trackSocial(event) {
    const network = event.currentTarget.dataset.shareLinksNetworkParam;
    this.#track(network);
  }

  #track(network) {
    window.mixpanel?.track('contest_entry_shared', {
      contest_id: this.contestIdValue,
      board_id: this.boardIdValue,
      network,
    });
  }
}
